// src/pages/admin/UnauthorizedPage.js

import React from 'react';
import { useNavigate } from 'react-router-dom';

const UnauthorizedPage = () => {
	const navigate = useNavigate();

	return (
		<div className="flex items-center justify-center min-h-screen bg-gray-100 p-4">
			<div className="bg-white rounded-lg shadow-xl p-8 max-w-md w-full text-center">
				<h1 className="text-4xl font-bold text-red-600 mb-4">403</h1>
				<h2 className="text-2xl font-semibold text-gray-800 mb-6">Unauthorized Access</h2>
				<p className="text-gray-600 mb-8">
					You do not have the necessary permissions to view this page. Please contact your
					administrator if you believe this is an error.
				</p>
				<div className="flex flex-col space-y-4">
					<button
						onClick={() => navigate(-1)}
						className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
					>
						Go Back
					</button>
				</div>
			</div>
		</div>
	);
};

export default UnauthorizedPage;
